/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import 'react-day-picker/lib/style.css';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import MomentLocaleUtils, { formatDate, parseDate } from 'react-day-picker/moment';

import { TYPES_VIEW } from '../../constans/types-view';
import { switchDateAction, switchTypeAction } from '../filter/actions';
import { getScheduleAction } from '../schedule/actions';
import { updateTooltipAction } from '../tooltip/actions';
import { ReactComponent as ArrowDoubleIcon } from '../../assets/double-arrow.svg';
import { ReactComponent as ArrowIcon } from '../../assets/arrow.svg';
import { setScheduleInterval } from '../../helpers';
import './style.scss';

const Navbar = ({ onPreviousClick, onNextClick, className }) => (
    <div className={className}>
        <button type="button" className={`${className}_prev`} onClick={() => onPreviousClick()}>
            <ArrowIcon />
        </button>
        <button type="button" className={`${className}_next`} onClick={() => onNextClick()}>
            <ArrowIcon />
        </button>
    </div>
);

class OverlayReactDayPicker extends React.PureComponent {
    componentWillUnmount() {
        const overlayEl = document.querySelector('#DayPickerInput-OverlayWrapperAnimate');
        const containerEl = overlayEl ? overlayEl.parentElement : null;
        const clonedOverlayEl = overlayEl ? overlayEl.cloneNode(true) : null;

        if (!clonedOverlayEl) return;

        clonedOverlayEl.classList.add('DayPickerInput-OverlayWrapper--close');
        clonedOverlayEl.addEventListener('animationend', () => {
            containerEl.removeChild(clonedOverlayEl);
        });

        containerEl.appendChild(clonedOverlayEl);
    }

    render() {
        const {
            children,
            classNames,
            selectedDay,
            ...otherProps
        } = this.props;

        return (
            <div
                className={classNames.overlayWrapper}
                id={`${classNames.overlayWrapper}Animate`}
                selectedday={selectedDay}
                {...otherProps}
            >
                <div className={classNames.overlay}>
                    {children}
                </div>
            </div>
        );
    }
}

Navbar.defaultProps = {
    onPreviousClick: null,
    onNextClick: null,
    className: ''
};
Navbar.propTypes = {
    onPreviousClick: PropTypes.func,
    onNextClick: PropTypes.func,
    className: PropTypes.string
};
OverlayReactDayPicker.propTypes = {
    children: PropTypes.object.isRequired,
    classNames: PropTypes.object.isRequired,
    selectedDay: PropTypes.object.isRequired
};


class Navigation extends React.Component {
    constructor() {
        super();
        this.prevTooltipRef = React.createRef();
        this.nextTooltipRef = React.createRef();
        this.dateTooltipRef = React.createRef();
    }

    componentDidUpdate(prevProps) {
        const { filter: prevFilter } = prevProps;
        const { filter, dispatch } = this.props;
        if (prevFilter.typeView.value !== filter.typeView.value) {
            const tooltipText = this.generateTooltipText();
            const { nextText } = tooltipText;
            const { prevText } = tooltipText;

            dispatch(updateTooltipAction('nav-prev', [{ type: 'text', data: prevText }]));
            dispatch(updateTooltipAction('nav-next', [{ type: 'text', data: nextText }]));
        }
    }

    generateTooltipText = () => {
        const { filter } = this.props;
        let nextText = 'Вперёд на месяц';
        let prevText = 'Назад на месяц';

        switch (filter.typeView.value) {
            case 'day': {
                const newDateNext = moment(filter.date).add(1, 'd');
                const newDatePrev = moment(filter.date).subtract(1, 'd');
                nextText = newDateNext.format('dddd, DD.MM');
                prevText = newDatePrev.format('dddd, DD.MM');
                break;
            }
            case 'week':
                nextText = 'Вперёд на 7 дней';
                prevText = 'Назад на 7 дней';
                break;
            case 'month':
                nextText = 'Вперёд на месяц';
                prevText = 'Назад на месяц';
                break;
            default:
                break;
        }

        return { nextText, prevText };
    }

    switchDate = (type) => {
        const { dispatch, filter } = this.props;
        const { date: curDate, typeView } = filter;
        let date = moment(curDate);

        switch (typeView.value) {
            case 'day': {
                switch (type) {
                    case 'prev':
                        date = date.subtract(1, 'd');
                        break;
                    case 'next':
                        date = date.add(1, 'd');
                        break;
                    default:
                        break;
                }
                break;
            }
            case 'week': {
                switch (type) {
                    case 'prev':
                        date = date.subtract(6, 'd');
                        break;
                    case 'next':
                        date = date.add(6, 'd');
                        break;
                    default:
                        break;
                }
                break;
            }
            default: {
                switch (type) {
                    case 'prev':
                        date = date.subtract(1, 'M');
                        break;
                    case 'next':
                        date = date.add(1, 'M');
                        break;
                    default:
                        break;
                }
            }
        }

        dispatch(getScheduleAction({ ...filter, date }));
        dispatch(switchDateAction(date));
        setScheduleInterval({ ...filter, date }, dispatch);
    }

    selectDate = (date) => {
        const { dispatch, filter } = this.props;
        const typeView = filter.typeView.value === 'month' ? TYPES_VIEW[0] : filter.typeView;
        dispatch(getScheduleAction({ ...filter, date, typeView }));
        dispatch(switchDateAction(date));
        dispatch(switchTypeAction(typeView));
        setScheduleInterval({ ...filter, date, typeView }, dispatch);
    }

    render() {
        const { filter } = this.props;
        const { typeView } = filter;
        let dateTextFormat = 'MMMM';
        let dateText = filter.date.format(dateTextFormat);
        let DateText = () => '';
        let nextTextTooltip = '';
        let prevTextTooltip = '';
        const minDate = +moment().set({ hour: 0, minute: 0, second: 0 }).format('X');
        const maxDate = +moment().add(8, 'weeks').set({ hour: 0, minute: 0, second: 0 }).format('X');
        let showPrev = true;
        let showNext = true;

        if (typeView) {
            const tooltipText = this.generateTooltipText();
            nextTextTooltip = tooltipText.nextText;
            prevTextTooltip = tooltipText.prevText;
            switch (typeView.value) {
                case 'day': {
                    dateTextFormat = 'dd, DD.MM.YYYY';
                    DateText = () => (
                        <>
                            <span>{filter.date.format('dd,')}</span>
                            &nbsp;
                            {filter.date.format('DD.MM.YYYY')}
                        </>
                    );
                    const currentDate = +moment(filter.date).set({ hour: 0, minute: 0, second: 0 }).format('X');
                    showPrev = currentDate === minDate;
                    showNext = currentDate === maxDate;
                    break;
                }
                case 'week': {
                    const newDateNext = moment(filter.date).add(6, 'd');
                    dateTextFormat = 'DD.MM.YYYY';
                    dateText = `${filter.date.format(dateTextFormat)} - ${newDateNext.format(dateTextFormat)}`;
                    const currentDate = +moment(filter.date).set({ hour: 0, minute: 0, second: 0 }).format('X');
                    showPrev = currentDate === minDate;
                    showNext = +moment(newDateNext).set({ hour: 0, minute: 0, second: 0 }).format('X') >= maxDate;
                    break;
                }
                default: {
                    const currentDate = +moment(filter.date).set({ hour: 0, minute: 0, second: 0 }).format('X');
                    showPrev = currentDate === minDate;
                    showNext = currentDate === maxDate;
                    break;
                }
            }
        }

        return (
            <div className="schedule__navigation">
                <div className="schedule__navigation_button-wrap">
                    <div className="tooltip" ref={this.prevTooltipRef}>
                        {prevTextTooltip}
                    </div>
                    <button
                        type="button"
                        className="schedule__navigation_button schedule__navigation_prev"
                        onClick={() => this.switchDate('prev')}
                        disabled={showPrev === null}
                        onMouseOver={() => {
                            this.prevTooltipRef.current.classList.add('show');
                        }}
                        onMouseLeave={() => {
                            this.prevTooltipRef.current.classList.remove('show');
                        }}
                    >
                        <ArrowDoubleIcon />
                    </button>
                </div>
                <div className="schedule__navigation_date">
                    <DayPickerInput
                        formatDate={formatDate}
                        parseDate={parseDate}
                        value={formatDate(filter.date, dateTextFormat, 'ru')}
                        format={dateTextFormat}
                        placeholder="Дата"
                        onDayChange={(date) => { this.selectDate(moment(date)); }}
                        dayPickerProps={{
                            locale: 'ru',
                            localeUtils: MomentLocaleUtils,
                            navbarElement: <Navbar />,
                            disabledDays: {
                                before: moment().toDate(),
                                after: moment().add(8, 'weeks').toDate()
                            },
                            selectedDays: filter.date.toDate()
                        }}
                        component={props => (
                            <>
                                <div className="tooltip" ref={this.dateTooltipRef}>Выберите дату</div>
                                <span
                                    className="text-date"
                                    style={{ textTransform: typeView.value === 'month' ? 'uppercase' : 'initial' }}
                                >
                                    {typeView.value === 'day' ? <DateText /> : dateText}
                                </span>
                                <input
                                    {...props}
                                    readOnly
                                    onMouseOver={() => {
                                        this.dateTooltipRef.current.classList.add('show');
                                    }}
                                    onMouseLeave={() => {
                                        this.dateTooltipRef.current.classList.remove('show');
                                    }}
                                />
                            </>
                        )}
                        overlayComponent={OverlayReactDayPicker}
                        inputProps={{ ref: null }}
                    />
                </div>
                <div className="schedule__navigation_button-wrap">
                    <div className="tooltip" ref={this.nextTooltipRef}>
                        {nextTextTooltip}
                    </div>
                    <button
                        type="button"
                        className="schedule__navigation_button schedule__navigation_next"
                        onClick={() => this.switchDate('next')}
                        disabled={showNext === null}
                        onMouseOver={() => {
                            this.nextTooltipRef.current.classList.add('show');
                        }}
                        onMouseLeave={() => {
                            this.nextTooltipRef.current.classList.remove('show');
                        }}
                    >
                        <ArrowDoubleIcon />
                    </button>
                </div>
            </div>
        );
    }
}

Navigation.propTypes = {
    dispatch: PropTypes.func.isRequired,
    filter: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    filter: state.filter
});

export default connect(mapStateToProps)(Navigation);
